import Dashboard from '../views/index';
import AlbumPage from '../views/album';
import WishForm from '../views/wish';
import GiftForm from '../views/gift';
import WishLandingPage from '../views/wish-landing';
import GiftLandingPage from '../views/gift-landing';

export const routes = [
  {
    path: '/',
    element: Dashboard,
    name: 'Index'
  },
  {
    path: '/:id',
    element: Dashboard,
    name: 'Index'
  },
  {
    path: '/:id/album',
    element: AlbumPage,
    name: 'Album'
  },
  {
    path: '/:id/wish',
    element: WishForm,
    name: 'Wish'
  },
  {
    path: '/:id/wish-landing',
    element: WishLandingPage,
    name: 'Wish Landing'
  },
  {
    path: '/:id/gift-landing',
    element: GiftLandingPage,
    name: 'Gift Landing'
  },
  {
    path: '/:id/gift',
    element: GiftForm,
    name: 'Gift'
  },
  // preview routes (follow ตามนี้)
  {
    path: '/:id/preview',
    element: Dashboard,
    name: 'Index Preview'
  },
  {
    path: '/:id/preview/album',
    element: AlbumPage,
    name: 'Album Preview'
  },
  {
    path: '/:id/preview/wish',
    element: WishForm,
    name: 'Wish Preview'
  },
  {
    path: '/:id/preview/wish-landing',
    element: WishLandingPage,
    name: 'Wish Landing Preview'
  },
  {
    path: '/:id/preview/gift-landing',
    element: GiftLandingPage,
    name: 'Gift Landing Preview'
  },
  {
    path: '/:id/preview/gift',
    element: GiftForm,
    name: 'Gift Preview'
  }
];
